import httpClient from './httpClient';
import type {
  StockItem,
  StockFilters,
  PagedResult,
  ReceiptItem,
  CreateReceiptResult,
  CreateShipmentRequest,
  ShipmentResult,
  CreateAdjustmentRequest,
  WarehouseLocation,
  CreateLocationRequest,
  BatchOperationLog,
  BatchAllocation,
} from '@/types/warehouse';

export const warehouseApi = {
  async getStock(mdFilters: StockFilters): Promise<PagedResult<StockItem>> {
    const mdParams: Record<string, string | number> = {
      page: mdFilters.page,
      pageSize: mdFilters.pageSize,
    };
    if (mdFilters.search) mdParams.search = mdFilters.search;
    if (mdFilters.status) mdParams.status = mdFilters.status;
    if (mdFilters.expiryDays) mdParams.expiryDays = mdFilters.expiryDays;
    if (mdFilters.locationCode) mdParams.locationCode = mdFilters.locationCode;

    const mdResponse = await httpClient.get<PagedResult<StockItem>>('/warehouse/stock', {
      params: mdParams,
    });
    return mdResponse.data;
  },

  async getProductStock(mdProductId: string): Promise<StockItem[]> {
    const mdResponse = await httpClient.get<StockItem[]>(`/warehouse/stock/${mdProductId}`);
    return mdResponse.data;
  },

  async createReceipt(mdItems: ReceiptItem[]): Promise<CreateReceiptResult> {
    const mdResponse = await httpClient.post<CreateReceiptResult>('/warehouse/receipts', {
      items: mdItems,
    });
    return mdResponse.data;
  },

  async createShipment(mdRequest: CreateShipmentRequest): Promise<ShipmentResult> {
    const mdResponse = await httpClient.post<ShipmentResult>('/warehouse/shipments', mdRequest);
    return mdResponse.data;
  },

  async createAdjustment(mdRequest: CreateAdjustmentRequest): Promise<void> {
    await httpClient.post('/warehouse/adjustments', mdRequest);
  },

  async getExpiringBatches(mdDays: number): Promise<StockItem[]> {
    const mdResponse = await httpClient.get<StockItem[]>('/warehouse/expiring', {
      params: { days: mdDays },
    });
    return mdResponse.data;
  },

  async getLocations(): Promise<WarehouseLocation[]> {
    const mdResponse = await httpClient.get<WarehouseLocation[]>('/warehouse/locations');
    return mdResponse.data;
  },

  // Сервер повертає Guid створеної локації
  async createLocation(mdRequest: CreateLocationRequest): Promise<string> {
    const mdResponse = await httpClient.post<string>('/warehouse/locations', mdRequest);
    return mdResponse.data;
  },

  // Маршруту на сервері ще немає (server gap) — UI обробляє помилку
  async getBatchOperations(mdBatchId: string): Promise<BatchOperationLog[]> {
    const mdResponse = await httpClient.get<BatchOperationLog[]>(
      `/warehouse/batches/${mdBatchId}/operations`
    );
    return mdResponse.data;
  },

  // Маршруту на сервері ще немає (server gap) — UI обробляє помилку
  async getFefoPreview(mdProductId: string, mdQuantity: number): Promise<BatchAllocation[]> {
    const mdResponse = await httpClient.get<BatchAllocation[]>('/warehouse/shipments/preview', {
      params: { productId: mdProductId, quantity: mdQuantity },
    });
    return mdResponse.data;
  },
};
